// src/modules/auth/services/requestAnotherCode.ts

import { sendRequest } from "../../../utils/request.ts";
import { showToast } from "../../../utils/toast.tsx";

interface Params {
  email: string;
  buttonId: string;
}

export const requestAnotherCode = async ({ email, buttonId }: Params) => {
  await sendRequest({
    request: {
      url: "/api/auth/request-code",
      method: "POST",
      body: { email },
    },
    submitButton: {
      button: document.getElementById(buttonId) as HTMLButtonElement,
      text: "Wyślij ponownie kod",
    },
    errorMessage: "Podany adres email jest nieprawidłowy.",
    onSuccess: () => {
      showToast({ variant: "info", message: "Kod został wysłany ponownie" });
    },
  });
};
